import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { contains } from 'ramda';

import { routes } from '../../routes';

import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const propTypes = {
  location: PropTypes.object,
};

const Guest = ({ location }) => {
  if (!contains(location.pathname, [routes.login, routes.register, routes.resetPassword, routes.forgotPassword])) {
    try {
      localStorage.setItem('referrer', location.pathname);
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <main className="main-content-wrapper">
      <div className="container">
        <div className="row justify-content-center">
          <Switch>
            <Route path={routes.login} component={Login} />
            <Route path={routes.register} component={Register} />
            <Route path={routes.resetPassword} component={ResetPassword} />
            <Route path={routes.forgotPassword} component={ForgotPassword} />
            <Redirect to={routes.login} />
          </Switch>
        </div>
      </div>
    </main>
  );
};

Guest.propTypes = propTypes;

export default withRouter(Guest);
